import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ng2-tooltip-directive';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRippleModule } from '@angular/material/core';
import { FullLoaderComponent } from './full-loader.component';
import { Error404Component } from './error-404.component';
import { Error404KnowledgebaseComponent } from './error-404-knowledgebase.component';
import { Error500Component } from './error-500.component';
import { RouterModule } from '@angular/router';
import { EllipsisTooltipDirective } from './ellipsis-tooltip.directive';
import { AllPipeModule } from '../core/pipes/all-pipe.module';

@NgModule({
    declarations: [
        FullLoaderComponent,
        Error404Component,
        Error404KnowledgebaseComponent,
        Error500Component,
        EllipsisTooltipDirective,
    ],
    imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    TranslateModule,
    TooltipModule.forRoot({
        hideDelay: 0
    }),
    MatIconModule,
    MatDialogModule,
    MatRippleModule,
    RouterModule,
    MatDialogModule,
    AllPipeModule
],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        TooltipModule,
        MatIconModule,
        FullLoaderComponent,
        Error404Component,
        Error404KnowledgebaseComponent,
        Error500Component,
        EllipsisTooltipDirective,
    ]
})
export class SharedModule {
}
